
<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav class="sidenav doNotPrint" fixedInViewport="false"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [opened]="true">
      <mat-nav-list >
<!--        <a mat-list-item [routerLink]="'/AdminHome'"> Home </a>-->
<!--        &lt;!&ndash; <a mat-list-item [routerLink]="task.role_task_id.routing_path" *ngFor="let task of userTasks"> {{task.role_task_id.task_name}} </a> &ndash;&gt;-->
<!--      &lt;!&ndash; <a mat-list-item [routerLink]="'/Warehouse'"> WareHouse </a> &ndash;&gt;-->
<!--        &lt;!&ndash; <a mat-list-item [routerLink]="'/Formulation'"> Formulation </a> &ndash;&gt;-->
<!--        <a mat-list-item [routerLink]="'/Admin-Reports'"> Reports </a>-->

<!--        <a mat-list-item [routerLink]="'/All-Material-Stock'"> Materials </a>-->
       <!-- <a mat-list-item [routerLink]="'/All-Product-Stock'"> Products </a> -->
        <a mat-list-item [ngClass]="{'active-menu': item.role_id === selectedItem}"
           *ngFor="let item of menuOptions(); let i = index"
           (click)="selectedItem = item.role_id; getSelectChangeHandler(item.role_id)"> {{item.role_name}} </a>
        <hr>
           <!-- <ng-container *ngFor="let option of options">
            <ng-container *ngIf="!option.submenu; else submenu">
              <a mat-list-item [routerLink]="option.link">{{ option.role_name }}</a>
            </ng-container>
            <ng-template #submenu>
              <mat-list-item [matMenuTriggerFor]="option.label">
                {{ option.role_name }}
                <mat-icon mat-list-icon>arrow_drop_down</mat-icon>
              </mat-list-item>
              <mat-menu #{{ option.role_name }}="matMenu">
                <button mat-menu-item *ngFor="let subOption of option.submenu" [routerLink]="subOption.link">
                  {{ subOption.role_name }}
                </button>
              </mat-menu>
            </ng-template>
          </ng-container> -->


        <!-- <a mat-list-item [routerLink]="'/SO-Management'"> SO Management </a> -->
        <!-- <a mat-list-item [routerLink]="'/Customers'"> Customers </a>  -->

        <!-- <a mat-list-item [routerLink]="'/All-User'"> All Users </a>  -->
        <!-- <a mat-list-item [routerLink]="'/Materials'"> Materials </a> -->
        <!-- <a mat-list-item [routerLink]="'/Traceability'"> Traceability </a> -->
        <!-- <a mat-list-item [routerLink]="'/MLO-Management'"> MLO Management </a> -->
        <!-- <a mat-list-item [routerLink]="'/PO-Management'"> PO Management </a> -->
        <!-- <a mat-list-item [routerLink]="'/documents-component'"> Documents </a> -->

        <!-- <a mat-list-item [routerLink]="'/Forecast-Sales'">Forecast Scheduler</a> -->
        <!-- <a mat-list-item [routerLink]="'/Store-Managemant'"> Store Management </a>  -->
        <!-- <a mat-list-item [routerLink]="'/License-And-Billing'"> License And Billing </a>-->


        <!-- <a mat-list-item (click)="logout()"> Logout </a> -->
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
        <div class="sidenav-content-wrapper">
          <mat-toolbar class="example-toolbar">
              <mat-toolbar-row>
                <button mat-icon-button class="doNotPrint">
                  <mat-icon (click)="sidenav.toggle()">menu</mat-icon>
                </button>
                <!-- <h1 class="doNotPrint">AbleTrace</h1> -->
                <img src="../../assets/images/AbleTraceLogo.png" alt="logo" width="200px" height='50px' [routerLink]="'/AdminHome'" class="pointer">

                <div class="doNotPrint admin-dropdown mx-5">
                  <mat-form-field class="w-100">
                    <mat-select matNativeControl required [(value)]="selectedItem">
                         <mat-option [value]="item.role_id" *ngFor="let item of menuOptions(); let i = index" (click)="getSelectChangeHandler(selectedItem)">
                            {{item.role_name}}
                          </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="container-fluid doNotPrint">
                  <div class="d-flex flex-row justify-content-end align-items-center gap-2">
                    <p class="username" style="font-size:medium;padding-top: 15px;">Hi {{name}} <span *ngIf="company_name">({{company_name}})</span> ! </p>
                    <button mat-button [matMenuTriggerFor]="menu">
                      <mat-icon style="cursor:pointer;width:24px; height:24px; font-size: 24px;"> account_circle </mat-icon>
                    </button>
                    <button mat-button [matMenuTriggerFor]="menu" (click)="logout()">
                      <mat-icon style="cursor:pointer;"> logout </mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item  [routerLink]="'/Profile'">Profile</button>
                      <button mat-menu-item  [routerLink]="'/Change-password'" >Change Password</button>
                      <button mat-menu-item  (click)="logout()">Logout</button>
                    </mat-menu>
                    </div>
                  </div>
              </mat-toolbar-row>
            </mat-toolbar>
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
